import KnownInternalNames from "@layerswap/utils/known-ids";
import { defineWalletDescriptor } from "./defineWalletDescriptor";
import { readStorageJson } from "./persistedSession";
const TRON_NETWORKS = [KnownInternalNames.Networks.TronMainnet, KnownInternalNames.Networks.TronTestnet];
/**
 * Tree-shake-safe stand-in for `createTronProvider`. Defers `tronweb` +
 * `validator` (a transitive 125 KB dep of tronweb) + `bignumber.js` +
 * `google-protobuf` schemas — ~775 KB parsed / ~165 KB gzip — out of the
 * host's entry chunk.
 */
export function createTronDescriptor(options) {
    const supportedNetworks = options?.supportedNetworks ?? TRON_NETWORKS;
    return defineWalletDescriptor({
        id: 'tron',
        name: 'Tron',
        autofillSupportedNetworks: supportedNetworks,
        withdrawalSupportedNetworks: supportedNetworks,
        asSourceSupportedNetworks: supportedNetworks,
        hasPersistedSession: () => typeof readStorageJson('tronAdapterName') === 'string',
        loadProvider: async () => {
            const mod = await import('@layerswap/wallet-tron');
            return mod.createTronProvider();
        },
    });
}
